import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { HomeComponent } from './views/home/home.component';
import { LoginComponent } from './views/login/login.component';
import { PageComponent } from './views/page/page.component';
import { AuthGuard } from './helpers/index';
import { DraftComponent } from './views/draft/draft.component';
import { VersionComponent} from './views/version/version.component';
import { CanDeactivateGuard} from './services';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent,
  NoNavLayoutComponent
} from './containers';



export const routes: Routes = [
  { path: '',redirectTo: 'home', pathMatch: 'full' } ,
  { path: 'login',         component: LoginComponent,  data: { title: 'Login Page' }},
  { path: 'home',          component: HomeComponent,        canActivate: [AuthGuard]},
  { path: 'page/:id',      component: PageComponent},
  { path: 'Draft/:id',      component: DraftComponent},
  { path: 'Version/:id',      component: VersionComponent},
  { path: 'Dashboard',     canActivate: [AuthGuard], 
    children: [
        { path: ':sysName',   canActivate: [AuthGuard],
          children: [
            { path: ':parentItem',  canActivate: [AuthGuard],
              children: [
                            { path: ':id', component: DashboardComponent,   canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] }
                        ]
            },
          ]
        }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts